import React from 'react';
import { AdminLayout } from '../../../design-system/components/layouts';
import { PageHeader } from '../../../design-system/components';
import { admin_campaign_path } from '../../../lib/routes';
import CampaignForm from './CampaignForm';
export default function Edit({ campaign }) {
  return (
    <AdminLayout>
      <PageHeader title={`Edit: ${campaign.name}`} description="Update campaign settings" />

      <div className="mt-6">
        <CampaignForm
          campaign={campaign}
          action={admin_campaign_path(campaign.id)}
          method="patch"
        />
      </div>
    </AdminLayout>
  );
}
